import { useState } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n, LANGS } from "../../context/LanguageContext";

export default function LanguageSwitcher({ onHero = false }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  const triggerCls = onHero ? "border-white/25 text-white hover:bg-white/10" : "border-border hover:bg-secondary";
  return (
    <div className="relative">
      <button data-testid="lang-switcher" onClick={() => setOpen((o) => !o)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        className={`w-10 h-10 sm:w-auto sm:px-3 rounded-full border flex items-center justify-center gap-1.5 transition-colors ${triggerCls}`}>
        <Globe className="w-4 h-4" /> <span className="hidden sm:inline text-xs font-semibold">{current.label}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-32 rounded-xl glass border border-border p-1 z-[70]">
          {LANGS.map((l) => (
            <button key={l.code} data-testid={`lang-${l.code}`} onMouseDown={() => { setLang(l.code); setOpen(false); }}
              className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm hover:bg-secondary transition-colors">
              {l.label === "EN" ? "English" : l.label === "ES" ? "Español" : "Français"}
              {l.code === lang && <Check className="w-3.5 h-3.5 text-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
